// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"203":"bf3d6587","533":"ed0936cc"}[chunkId] + ".chunk.js";
};